import _ from 'lodash';
import AdministratorRightsGql from '@/store/graphql/system/queries/AdministratorRights.gql';

import { adminClient as apolloClient, defaultClient as publicApolloClient } from '@/store/apollo';

import TeamMemberGql from '@/store/graphql/system/queries/TeamMember.gql';
import ValidateTeamMemberInvitationGql from '@/store/graphql/system/queries/ValidateTeamMemberInvitation.gql';
import AcceptTeamMemberInvitationGql from '@/store/graphql/system/mutations/AcceptTeamMemberInvitation.gql'
// import OwnersPaginatedGql from '@/store/graphql/system/queries/OwnersPaginated.gql';
import TeamMembersPaginatedGql from '@/store/graphql/system/queries/TeamMembersPaginated.gql';
import CreateTeamMemberGql from '@/store/graphql/system/mutations/CreateTeamMember.gql';
import UpdateTeamMemberGql from '@/store/graphql/system/mutations/UpdateTeamMember.gql';
// import DeleteTeamMemberGql from '@/store/graphql/system/mutations/DeleteTeamMember.gql';

export default {
    fetchTeamMembersPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: TeamMembersPaginatedGql,
                    variables: {
                        initiator: parseInt(data.initiator),
                        scope: _.get(data, 'scope', 'base'),
                        type: _.get(data, 'type', 'administrator_team'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        // link: '/system/team/',
                        filters
                    }
                })
                .then(({ data }) => resolve(data.TeamMembersPaginated))
                .catch(err => reject(err));
        }),
    // fetchOwnersPaginated: data =>
    //     new Promise((resolve, reject) => {
    //         let filters = [];
    //         _.each(data.filters, entry => filters.push(entry));

    //         apolloClient
    //             .query({
    //                 query: OwnersPaginatedGql,
    //                 variables: {
    //                     currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //                     perPage: _.get(data, 'pageInfo.perPage', 25),
    //                     order: _.get(data, 'variables.order', 'id'),
    //                     direction: _.get(data, 'variables.direction', 'asc'),
    //                     config: 'base.pagination.account',
    //                     link: '/system/account/',
    //                     filters
    //                 }
    //             })
    //             .then(({ data }) => resolve(data.OwnersPaginated))
    //             .catch(err => reject(err));
    //     }),
    fetchTeamMember: (id, initiator) => {
        if (id === undefined) throw new Error('required argument is missing');
        if (initiator === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TeamMemberGql,
                    variables: {
                        id: parseInt(id),
                        initiator: parseInt(initiator),
                    },
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.TeamMember))
                .catch(err => reject(err));
        });
    },
    validateInvitation: token => {
        if (token === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            publicApolloClient
                .query({
                    query: ValidateTeamMemberInvitationGql,
                    variables: { token },
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.ValidateTeamMemberInvitation))
                .catch(err => reject(err));
        });
    },
    acceptInvitation: (teamMember, token) => {
        if (teamMember === undefined) throw new Error('required argument is missing');
        return new Promise((resolve, reject) => {
            publicApolloClient
                .mutate({
                    mutation: AcceptTeamMemberInvitationGql,
                    variables: {
                        teamMember: _.removeDeepByKey(teamMember, '__typename'),
                        token,
                    },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.AcceptTeamMemberInvitation);
                })
                .catch(err => reject(err));
        });
    },
    create: (teamMember, initiator) => {
        if (teamMember === undefined) throw new Error('required argument is missing');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateTeamMemberGql,
                    variables: {
                        teamMember: _.removeDeepByKey(teamMember, '__typename'),
                        initiator: parseInt(initiator),
                    },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CreateTeamMember);
                })
                .catch(err => reject(err));
        });
    },
    update: (teamMember, initiator) => {
        if (teamMember === undefined) throw new Error('required argument is missing');
        if (initiator === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateTeamMemberGql,
                    variables: {
                        teamMember: _.removeDeepByKey(teamMember, '__typename'),
                        initiator: parseInt(initiator),
                    },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.UpdateTeamMember);
                })
                .catch(err => reject(err));
        });
    },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing');

    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: DeleteTeamMemberGql,
    //                 variables: { id: parseInt(id) }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_DeleteTeamMember);
    //             })
    //             .catch(err => reject(err));
    //     });
    // },

    fetchAdministratorRights: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: AdministratorRightsGql, fetchPolicy: 'cache-first' })
                .then(({ data }) => resolve(data.AdministratorRights || []))
                .catch((err) => reject(err));
        }),
}
